<template>
  <el-form-item
    :label="name"
    :prop="code"
    :rules="rules"
  >
    <el-popover v-model="visiable" :disabled="disabled" placement="bottom-start" trigger="focus">
      <template #default>
        <!-- 原有弹窗内容不变 -->
        <div class="flex justify-between align-center mb-10">
          <el-input
            v-model="searchName"
            class="mr-10"
            placeholder="请输入内容,按回车搜索"
            prefix-icon="el-icon-search"
            @change="search"
          />
          <el-tooltip content="点击清除数据" placement="top">
            <i class="el-icon-delete" style="font-size: 20px;" @click="deleteItem" />
          </el-tooltip>
          <el-tooltip content="点击关闭" placement="top">
            <span class="cursor-pointer" style="font-size: 25px" @click="closepop">
              <svg-icon icon-class="close" />
            </span>
          </el-tooltip>
        </div>
        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="data"
          class="mb-10"
          row-key="code"
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <template v-for="(item,index) in filedList">
            <table-select-item
              v-if="item.type==='select'"
              :key="index"
              :code="item.code"
              :edit="false"
              :name="item.name"
              :options="item.options"
              key-field="key"
              value-field="value"
              width="120"
            />
            <table-image-item
              v-else-if="item.type==='image'"
              :key="index"
              :code="item.code"
              :edit="false"
              :name="item.name"
            />
            <table-group-item
              v-else-if="item.type==='group'"
              :key="index"
              :code="item.code"
              :edit="false"
              :name="item.name"
            />
            <el-table-column
              v-else
              :key="index"
              :label="item.name"
              :property="item.code"
              align="center"
              width="120"
            >
              <template #default="scope">
                <span class="text-ellipsis"> {{ scope.row[item.code] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <el-pagination
          :current-page.sync="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          background
          layout="prev, pager, next ,total"
          @current-change="pageChange"
        />
      </template>
      <template #reference>
        <!-- 核心修改：添加 @mousedown.prevent 阻止禁用态点击聚焦 -->
        <el-input
          v-model="result"
          :disabled="disabled"
          @focus="handleSearch()"
          @mousedown.prevent="handleInputMousedown"
        />
      </template>
    </el-popover>
  </el-form-item>
</template>

<script>
import { DataTableMixin } from "@/components/ik/form/popup/mixins/tableMethod"

export default {
  name: "IkFormPopupSelect",
  mixins: [DataTableMixin],
  props: {
    require: { type: Boolean, default: false },
    rules: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    name: { type: String, default: "" },
    filedList: {
      type: Array,
      default: function() {
        return [
          { code: 'id', name: 'ID' },
          { code: 'code', name: '编码' },
          { code: 'name', name: '名称' }
        ]
      }
    },
    code: { type: String, default: "" },
    value: { type: String, default: "" },
    valueCode: { type: String, default: "code" },
    callback: { type: Function, default: () => {} }
  },
  data() {
    return {
      result: "",
      visiable: false
    }
  },
  computed: {
    getRequire() { return this.require }
  },
  watch: {
    value(val) {
      this.result = val
      this.callback(val)
    }
  },
  mounted() {
    this.result = this.value
    // 新增：禁用时不执行初始搜索
    if (!this.disabled) {
      this.search()
    }
  },
  methods: {
    handleSearch() {
      console.log("handleSearch")
      // 强化判断：禁用时直接关闭弹窗并返回
      if (this.disabled) {
        this.visiable = false
        return
      }
      this.search()
    },
    // 新增：阻止禁用态 input 的点击默认行为
    handleInputMousedown() {
      if (this.disabled) {
        this.visiable = false
      }
    },
    closepop() {
      this.visiable = false
    },
    deleteItem() {
      this.visiable = false
      this.$emit('onPopupClick', this.code, '')
    },
    handleRowClick(row) {
      this.$emit('onPopupClick', this.code, row)
      this.visiable = false
      this.result = row[this.valueCode]
      this.callback(this.result)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
